import React from 'react';
import Button from "@material-ui/core/Button/Button";
import { makeStyles } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField/TextField";
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import Grid from "@material-ui/core/es/Grid/Grid";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import PriceWrapper from "./Price/PriceWrapper";
import MakeWrapper from "./Make/MakeWrapper";
import ModelWrapper from "./Model/ModelWrapper";
import TrimWrapper from "./Trim/TrimWrapper";
import YearWrapper from "./Year/YearWrapper";
import LocationWrapper from "./Location/LocationWrapper";
import SearchWrapper from "./Search/SearchWrapper";

const useStyles = makeStyles({
    root: {
        padding: 20
    },
    block: {
        width: 280,
        position: 'relative',
    },
    blockHeader: {
        border: '1px dashed #ccc',
        paddingTop: 5,
        paddingLeft: 20,
        paddingBottom: 5

    },
    blockBody: {
        border: '1px solid #ccc',
        borderTop: 'none',
    },

});

const useStylesFilter = makeStyles({
    root: {
        padding: '10px 10px 0 10px',
        width: '100%'
    },
    block: {
        borderBottom: '1px solid #ccc',
        minHeight: 50,
        position: 'relative'
    },
    blockHeader: {
        padding: '14px 10px 5px 20px',
        cursor: 'pointer'
    },
    makes: {
        marginBottom: 20,
    },
    makesCont: {
        maxHeight: 300,
        overflowY: 'hidden'
    },
    opener: {
        position: 'absolute',
        right: 10,
        top: 14,
        cursor: 'pointer',
    },
    progress: {
        position: 'absolute',
        top: 10,
        right: 10,
    },
});

export default function FilterFormDesktop(props) {

    const classes = useStyles();
    const filterClasses = useStylesFilter();

    return (
        <div className={classes.block}>
            <div className={classes.blockHeader}>
                <Typography>Filter Results</Typography>
                {props.filter.params.isLoadingResults ? <CircularProgress size={20} className={classes.progress}/> : null}
            </div>
            <div className={classes.blockBody}>
                <SearchWrapper filter={props.filter} isMobile={false} classes={filterClasses}/>
                <LocationWrapper filter={props.filter} isMobile={false} classes={filterClasses}/>
                <YearWrapper filter={props.filter} isMobile={false} classes={filterClasses}/>
                <MakeWrapper filter={props.filter} isMobile={false} classes={filterClasses}/>
                <ModelWrapper filter={props.filter} isMobile={false} classes={filterClasses}/>
                <TrimWrapper filter={props.filter} isMobile={false} classes={filterClasses}/>
                <PriceWrapper filter={props.filter} isMobile={false} classes={filterClasses}/>
            </div>
        </div>
    )
}